import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PhoneInput } from './PhoneInput';
import { NumericKeypad } from './NumericKeypad';
import { Trophy, Crown } from 'lucide-react';
import { saveCustomer, saveVisit, getCustomer } from '../services';
import { Header } from './Header';
import { useEstablishmentStore } from '../store/establishment';

export default function CustomerEntry() {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { establishment } = useEstablishmentStore();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!establishment || phone.length !== 11) return;

    setLoading(true);
    setError(null);

    try {
      const existingCustomer = await getCustomer(establishment.id, phone);
      
      if (existingCustomer) {
        await saveVisit(establishment.id, phone, {
          date: new Date().toISOString(),
          points: establishment.settings.pointsPerVisit,
          visitNumber: (existingCustomer.totalVisits || 0) + 1,
          timestamp: new Date().toISOString(),
          pointsEarned: establishment.settings.pointsPerVisit,
          totalPointsAfter: (existingCustomer.points || 0) + establishment.settings.pointsPerVisit
        });
        navigate(`/points-summary/${phone}`);
      } else {
        navigate(`/registration/${phone}`);
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Ocorreu um erro. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleNumberClick = (num: string) => {
    if (phone.length < 11) {
      setPhone(phone + num);
    }
  };

  const handleDelete = () => {
    setPhone(phone.slice(0, -1));
  };

  const handleClear = () => {
    setPhone('');
  };

  if (!establishment) {
    navigate('/login');
    return null;
  }

  return (
    <div className="app-container flex items-center justify-center p-6">
      <Header />
      <div className="content-card">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="app-title">
              <Trophy className="w-8 h-8 text-yellow-400" strokeWidth={1.5} />
              <h1 className="app-name">FidelizApp</h1>
              <Crown className="w-8 h-8 text-yellow-400" strokeWidth={1.5} />
            </div>

            <p className="app-subtitle">
              Digite seu número para ganhar pontos
            </p>

            {error && (
              <div className="mb-6 p-4 bg-red-50 text-red-600 rounded-xl text-center">
                {error}
              </div>
            )}

            <PhoneInput
              value={phone}
              onChange={setPhone}
              className="phone-input"
            />

            <button
              onClick={handleSubmit}
              disabled={loading || phone.length !== 11}
              className="continue-button disabled:opacity-50"
            >
              {loading ? 'Verificando...' : 'Continuar'}
            </button>

            <button
              onClick={() => navigate('/admin')}
              className="admin-link"
            >
              Acesso Administrativo
            </button>
          </div>

          <div className="flex items-center justify-center">
            <NumericKeypad
              onNumberClick={handleNumberClick}
              onDelete={handleDelete}
              onClear={handleClear}
            />
          </div>
        </div>
      </div>
    </div>
  );
}